import { CurrencyCode } from '@src/types/common';

export function getCurrencySymbol(
  currencyCode?: string | CurrencyCode
): string {
  const symbols: Record<CurrencyCode, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    TRY: '₺',
  };

  const validCurrencyCodes: CurrencyCode[] = ['USD', 'EUR', 'GBP', 'TRY'];

  const normalized = currencyCode?.toUpperCase() as CurrencyCode;

  if (normalized && validCurrencyCodes.includes(normalized)) {
    return symbols[normalized];
  }

  return currencyCode ?? '$';
}

export function cleanNumberDisplay(value: number | string): string {
  const str = String(value).trim();
  const match = RegExp(/^(\d+)(\.\d+)?\s?(.*)$/).exec(str);

  if (!match) return str;

  const [, intPart, decimalPart, suffix] = match;

  const num = parseFloat(intPart + (decimalPart ?? ''));

  const formatted = num.toFixed(2).replace(/\.?0+$/, '');

  return suffix ? `${formatted} ${suffix}`.trim() : formatted;
}
